<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Detalhes"
    >
        <rkm-table
            :fields="fields"
            :items="atendimento.itens"
            :tbody-tr-class="rowClass"
            class="table-atendimento"
            foot-clone
            hide-filters
            hide-pagination
            no-footer-sorting
        >
            <template #thead-top>
                <rkm-tr>
                    <rkm-th :colspan="fields.length">
                        <h6><strong>{{ atendimento.pacienteNome }}</strong></h6>

                        <div class="atendimento-info">
                            <span><strong>Prontuário</strong> {{ atendimento.pacienteProntuario }}</span>
                            <span><strong>Especialidade</strong> {{ atendimento.especialidadeNome || '-' }}</span>
                            <span><strong>Data</strong> {{ atendimento.data }}</span>
                            <span><strong>Horário agendado</strong> {{ atendimento.horarioAgendado || '-' }}</span>
                            <span><strong>Horário de chegada</strong> {{ atendimento.horarioChegada }}</span>
                            <span><strong>Atraso</strong> {{ atendimento.atraso || '-' }}</span>
                            <span><strong>CID/CIAP</strong> {{ atendimento.cidsCiaps.length > 0 ? atendimento.cidsCiaps.join(' | ') : '-' }}</span>
                            <span><strong>Tempo total</strong> {{ atendimento.tempoTotal }}</span>
                        </div>
                    </rkm-th>
                </rkm-tr>
            </template>

            <template v-slot:cell(setorNome)="{ item, value }">
                <span v-if="item.evadido"><rkm-icon icon="exclamation-triangle" /> Evasão - {{ value }}</span>
                <span v-else-if="item.cancelamentoEvasao"><rkm-icon icon="reply" /> Cancelamento de evasão - {{ value }}</span>
                <span v-else>{{ value }}</span>
            </template>

            <template #foot(setorNome)>
                <span>Total</span>
            </template>

            <template #foot(tipoAtendimento)>
                <span></span>
            </template>

            <template #foot(usuarioNome)>
                <span></span>
            </template>

            <template #foot(ocupacaoCodigo)>
                <span></span>
            </template>

            <template #foot(data)>
                <span></span>
            </template>

            <template #foot(horarioChegada)>
                <span></span>
            </template>

            <template #foot(horarioInicio)>
                <span></span>
            </template>

            <template #foot(horarioConclusao)>
                <span></span>
            </template>

            <template #foot(tempoEspera)>
                <span>{{ atendimento.tempoTotalEspera }}</span>
            </template>

            <template #foot(tempoAtendimento)>
                <span>{{ atendimento.tempoTotalAtendimento }}</span>
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        atendimento: { itens: [], cidsCiaps: [] },
    }),
    methods: {
        open(atendimento) {
            this.atendimento = atendimento

            this.$refs.Modal.show()
        },
        rowClass(item, type) {
            if (type === 'row' && item && item.evadido) {
                return 'table-danger'
            }
        },
    },
    props: {
        fields: {
            required: true,
            type: Array,
        },
    },
}
</script>

<style scoped>
.table-atendimento >>> .atendimento-info > span:not(:last-of-type) {
    margin-right: 10px;
}
</style>
